import gql from 'graphql-tag';

export const UpdateContentPropertyMutation = gql`
	mutation UpdateContentPropertyMutation(
		$contentId: String!
		$propertyKey: String!
		$propertyValue: String
		$versionNumber: String
		$isDelete: Boolean
	) @experimental {
		experimentalUpdateContentProperty(
			contentId: $contentId
			propertyKey: $propertyKey
			propertyValue: $propertyValue
			versionNumber: $versionNumber
			isDelete: $isDelete
		) {
			success
			id
			key
			value
		}
	}
`;
